const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the add to news component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Categories} Categories injected to gain access to the Categories resource
 */
app.directive('showNews', ['Categories', function (Categories) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      content: '=',
      onChange: '&?',
      text: '=?'
    },
    template: require('../../../templates/directives/cms/show-news.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.catName = '';

      self.checkCurrent = function(late) {
        if ($scope.content && $scope.content.linked_category && $scope.content.linked_category.length) {
          for (var i = 0; i < $scope.content.linked_category.length; i++) {
            if ($scope.content.linked_category[i].toString() === self.category._id.toString()) {
              self.show = true;
              if (late) {
                if ($scope.$$phase) {
                  $scope.$apply();
                }
              }
              return;
            }
          }
        }
      };

      self.initialize = function() {
        Categories.find({
          fields: 'name',
          level: 10
        }).$promise
        .then(function(main) {
          self.show = false;
          if (!main && !main[0]) {
            return;
          }
          self.category = main[0];
          self.catName = self.category['name'];

          if ($scope.content) {
            self.checkCurrent();
          } else {
            var watchContent = $scope.$watch('content', function(newVal, oldVal) {
              if (newVal && !oldVal) {
                self.checkCurrent(true);
                watchContent();
              }
            });
          }

          $scope.$watch('news.show', function(newVal, oldVal) {
            var type = 'add';
            if (newVal === oldVal) {
              return;
            }
            if (!newVal) {
              type = 'remove';
            }

            for (var i = 0; i < $scope.content.linked_category.length; i++) {
              if ($scope.content.linked_category[i].toString() === self.category._id.toString()) {
                $scope.content.linked_category.splice(i, 1);
                if ($scope.onChange) {
                  $scope.onChange();
                }
                break;
              }
            }

            if (type === 'add') {
              $scope.content.linked_category.push(self.category._id);
              if ($scope.onChange) {
                $scope.onChange();
              }
            }
          });

          setTimeout(function() {
            self.checkCurrent(true);
          }, 1000);
        });
      };
      self.initialize();
    }],
    controllerAs: 'news'
  };
}]);
